// extracted by mini-css-extract-plugin
export default {"unselected":"vCdi5NrcZKtG9XzHMuJE"};